import { Component, OnInit, Output } from '@angular/core';
import { OrderComponent } from '../../order.component';
import { EventEmitter } from '@angular/core';
import { ShoppingCartHandlerService } from 'src/app/feature/payment/services';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
  selector: 'app-selectable-order',
  templateUrl: './selectable-order.component.html',
  styleUrls: ['./selectable-order.component.scss'],
})
export class SelectableOrderComponent extends OrderComponent implements OnInit {
  @Output('select') select: EventEmitter<undefined> = new EventEmitter();

  // TODO: @@@@ Inject handler
  private handler: any;
  constructor(
    shoppingCartHandler: ShoppingCartHandlerService,
    dialog: MatDialog,
    router: Router
  ) {
    super(shoppingCartHandler, dialog, router);
  }

  public toggleSelect() {
    if (!parseInt(this.orderObject?.price)) {
      return;
    }
    this.orderObject.selected = !!!this.orderObject.selected;
  }

  public get isSelectable() {
    return !!parseInt(this.orderObject.price);
  }
}
